import _ from "lodash";

export const getServerResponse = (speechObj, server_response, speechData, bookId) => {
    let totalRedScore = 0;
    // let totalScore = 0;
    JSON.parse(speechData.analysis).NBest[0].Words.forEach((item, index) => {
        totalRedScore += item.AccuracyScore < 50 ? 3 : 0;
        // totalScore += item.AccuracyScore < 90 ? item.AccuracyScore < 50 ? 3 : 1 : 0; 
    });
    speechObj.score = totalRedScore;
    if (_.isEmpty(server_response)) {
        server_response = {
            bookId,
            student_speech: [speechObj]
        }
    } else {
        if (_.isEmpty(server_response.student_speech)) {
            server_response.student_speech = [speechObj];
        } else {
            let matchedIndex = server_response.student_speech.findIndex(item => {
                return item.index === speechObj.index;
            });
            if (matchedIndex === -1) {
                server_response.student_speech.push(speechObj);
            } else {
                server_response.student_speech[matchedIndex] = speechObj;
            }
        }
    }
    localStorage.setItem(`server_response`, JSON.stringify(server_response));
    return server_response;
}

export const isWindowAvailable = () => {
    if (typeof window != 'undefined') {
        return true;
    }
    return false;
}


export const isMacintosh = () => {
    if (typeof window != 'undefined') {
        return window.navigator.platform.indexOf('Mac') > -1
    }
    return false;
}

export const isWindows = () => {
    if (typeof window != 'undefined') {
        return window.navigator.platform.indexOf('Win') > -1
    }
    return false;
}

export const deviceInfo = () => {
    let isIpad = /iPad/.test(navigator.userAgent) && !window.MSStream
    let checkMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || Math.min(window.screen.width, window.screen.height) < 768
    let checkBrowser = false;
    if(/MacIntel/i.test(navigator.platform) || /Macintosh/i.test(navigator.userAgent)){
        if(navigator.maxTouchPoints && navigator.maxTouchPoints > 2){             
            isIpad = true
        }
    }
    var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf('chrome') > -1) {
            checkBrowser = true
        } else if (userAgent.indexOf('safari') > -1) {
            checkBrowser = true
        } else if (userAgent.indexOf('edg') > -1) {
            checkBrowser = true
        } else {
            checkBrowser = false
        }
        
        return {mobile: checkMobile || isIpad,browser: checkBrowser, isIpad}
};